import PropTypes from 'prop-types';
import React from 'react';
import Gallery from '../gallery/Gallery';
import {
    Card, CardImg, CardText, CardBlock,
    CardTitle, CardSubtitle, Button
} from 'reactstrap';

import './Feature.scss';

class Feature extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            open: false
        };
    }
    toggle() {
        this.setState({
            open: !this.state.open
        });
    }

    render() {
        return (
            <div className='feature-container'>
                <Card>
                    <Gallery
                        images={this.props.images}
                        showThumbnails={false}
                        isOpen={this.state.open}
                        onClose={() => this.toggle()}
                    />
                    <CardImg className='thumbnail' top src={this.props.thumbnail} onClick={() => this.toggle()} />
                    <CardBlock>
                        <CardTitle>{this.props.title}</CardTitle>
                        <CardSubtitle>{this.props.subtitle}</CardSubtitle>
                        <CardText>{this.props.description}</CardText>
                        {
                            this.props.moreInfoUrl
                            &&
                            <a href={this.props.moreInfoUrl}>More Info</a>
                        }
                    </CardBlock>
                </Card>
            </div>
        );
    }
}

Feature.displayName = 'Feature';
Feature.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    moreInfoUrl: PropTypes.string,
    description: PropTypes.string,
    thumbnail: PropTypes.string,
    images: PropTypes.array,
};

export default Feature;


// WEBPACK FOOTER //
// ./src/components/feature/Feature.jsx